import "antd/dist/reset.css";
import { Collapse } from "antd";
import React from "react";
import utils from "utils";
import DiagnosisAssessmentChart from "./DiagnosisAssessmentChart";
import { CONSTANTS } from "utils/constant";
const { Panel } = Collapse;

const DiagnosisSummaryChild = (props) => {
  return (
    <>
      {props.data?.completion_date ? (
        <Collapse
          style={{ overflowY: "auto" }}
          bordered={false}
          expandIconPosition="start"
          ghost={true}
          className="mhe-list-container"
        >
          <Panel
            header={<div> { utils.FormatDate(props?.data?.completion_date, "DATE_14")}, { utils.FormatDate(props?.data?.completion_date, "TIME_1")} </div>}
            key="1"
            extra={utils.FirstNameLastName(utils.salutationPrefixName(props?.data?.doctor_salutation, utils.getDisplayName(props?.data?.consultation_doctor, props?.data?.doctor_last_name)), "250px")}
          >
            <ConversionChecklist value={props?.data?.data}  type={props?.type}/>
          </Panel>
        </Collapse>
      ) : null}
    </>
  );
};

const ConversionChecklist = React.memo((props) => {
  let output = [];
  let assessmentValues = {};
  try {
    for (const [keys, values] of Object.entries(props.value || {})) {
      if(keys == "assessment"){assessmentValues = values;continue;};
      if (typeof values === "object") {
        for (const [key, value] of Object.entries(values || {})) {
          value
            ? output.push(key + " : " + utils.ConvertToPascalCase(value))
            : "";
        }
      } else {
        values
          ? output.push(keys + " : " + utils.ConvertToPascalCase(values))
          : "";
      }
    }
  } catch (err) {
    console.log(err);
    output.push("Something went wrong. : Please contact system administrator");
  } finally {
    return output.length > 0 ? 
      <>
      <DiagnosisAssessmentChart data={assessmentValues} type={props?.type}/>
      {output.map((i, j) => {
        let split = i.split(/:(.*)/s);
        split[0] = utils.ConvertToPascalCase(split[0]);
        return (
          <React.Fragment key={j}>
            <div className="mhe-box-content">
              <div className="mhe-box-content-label">
                <div style={{ fontWeight: "500", paddingLeft: "9px" }}>
                  {" "}
                  {split[0]}{" "}
                </div>
                <div> : </div>
                <div> {utils.LineSplit(split[1])}</div>
              </div>
            </div>
          </React.Fragment>
        );})
      }
      </>
       : (
      <div style={{ textAlign: "center" }}>No data found </div>
    );
  }
});

export default DiagnosisSummaryChild;
